export default {
  getImportHistory(state) {
    const uniqueObjects = [];
    const idSet = new Set();

    for (const obj of state.importHistory) {
      if (!idSet.has(obj.id)) {
        idSet.add(obj.id);
        uniqueObjects.push(obj);
      }
    }

    return uniqueObjects;
  },
};
